import React, { useState, useRef, useEffect } from "react";
import moment from 'moment';
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";

type ValuePiece = Date | null;
type Value = ValuePiece | [ValuePiece, ValuePiece];

interface IDateRangePicker {
    dateRange: [Date | null, Date | null],
    isOpen: boolean;
    setIsOpen: any;
    onChange: (newRange: any) => void;
}

const DateRangePicker = ({
    dateRange,
    isOpen,
    setIsOpen,
    onChange
}:IDateRangePicker) => {
 
  const calendarRef = useRef<HTMLDivElement | null>(null);
  const buttonRef = useRef<HTMLDivElement | null>(null);
  const [position, setPosition] = useState<"left" | "right">("left");


  // Handle positioning when opening the calendar
  useEffect(() => {
    if (isOpen && buttonRef.current && calendarRef.current) {
      const buttonRect = buttonRef.current.getBoundingClientRect();
      const calendarRect = calendarRef.current.getBoundingClientRect();
      const screenWidth = window.innerWidth;

      // Adjust position if calendar overflows on the right
      if (buttonRect.left + calendarRect.width > screenWidth) {
        setPosition("right");
      } else {
        setPosition("left");
      }
    }
  }, [isOpen]);

  return (
    <div className="relative inline-block">
      <div
        ref={buttonRef}
        className="flex flex-row text-sm items-center justify-around px-4 py-2 bg-white rounded-md cursor-pointer text-center font-semibold hover:bg-gray-50 transition"
        onClick={() => setIsOpen(!isOpen)}
      >
        <img src={'/assets/shared/calendar_month.svg'} className="object-contain mr-3 w-[18px]"/>
        {dateRange[0] && dateRange[1]
          ? `${moment(dateRange[0]).format('MMMM Do, YYYY')} - ${moment(dateRange[1]).format('MMMM Do, YYYY')}`
          : "Select a date range"}
      </div>

      {isOpen && (
        <div
          ref={calendarRef}
          className={`absolute top-full mt-2 bg-white border border-gray-300 shadow-lg z-10 rounded-md p-4 ${
            position === "right" ? "right-0" : "left-0"
          }`}
        >
          <Calendar
            onChange={onChange}
            value={dateRange}
            selectRange={true}
            maxDate={new Date()}
          />
        </div>
      )}
    </div>
  );
};

export default DateRangePicker;
